import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { faFile } from '@fortawesome/pro-solid-svg-icons';

import PageHeader from 'components/page_header';

import FileSystem from 'components/file_system';
import rootFolder from './sample_data/root_folder';
import { findIndex } from 'lodash';

export default class DocumentViewerSample extends React.Component {
  static propTypes = {
    styleGuidePath: PropTypes.string.isRequired
  }

  state = {
    navigation: [rootFolder],
    file: null
  }

  keyForFile = file => file.folder ? `folder${file.id}` : `file${file.id}`;

  handlePreview = (file) => {
    this.setState({ file });
  }

  handleNavigation = (folder) => {
    this.setState((prevState) => {
      const indexInStack = findIndex(this.state.navigation, { id: folder.id });

      if (indexInStack >= 0) {
        return { navigation: prevState.navigation.slice(0, indexInStack + 1) };
      } else {
        return { navigation: [...prevState.navigation, folder] };
      }
    });
  }

  currentFolder() {
    return this.state.navigation[this.state.navigation.length - 1];
  }

  renderCurrentItems() {
    return this.currentFolder().children.map((item, idx) => {
      return (
        <FileSystem.ListItem
          file={item}
          index={idx}
          key={this.keyForFile(item)}
          selected={item == this.state.file}
          onNavigation={this.handleNavigation}
          onPreview={this.handlePreview}
        />
      );
    });
  }

  renderBody() {
    return (
      <React.Fragment>
        <FileSystem.Breadcrumbs folders={this.state.navigation} onNavigation={this.handleNavigation} />
        <Row>
          <Col xs={3}>
            <FileSystem.List>
              {this.renderCurrentItems()}
            </FileSystem.List>
          </Col>
          <Col xs={9}>
            <FileSystem.Preview file={this.state.file}/>
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  render() {
    return (
      <div>
        <PageHeader
          iconDescription="Document Viewer"
          iconName={faFile}
          iconSize="lg"
          iconText="Documents"
          iconType="icon"
        >
          <a className="btn btn-dark" href={this.props.styleGuidePath}>
            Back to Style Guide
          </a>
        </PageHeader>
        <div className="container white mt-5">
          {this.renderBody()}
        </div>
      </div>
    );
  }
}
